/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import jsZip from 'jszip'
pdfMake.vfs = pdfFonts.pdfMake.vfs;
window.pdfMake = pdfMake;
window.JSZip = jsZip;

//datatables
require('datatables.net');
require('datatables.net-bs4');
require('datatables.net-fixedheader-bs4');
require('datatables.net-responsive-bs4');
require('datatables.net-buttons');
require('datatables.net-buttons-bs4');
require('datatables.net-buttons/js/dataTables.buttons.js');
require('datatables.net-buttons/js/buttons.colVis.js');
require('datatables.net-buttons/js/buttons.flash.js');
require('datatables.net-buttons/js/buttons.html5.js');
require('datatables.net-buttons/js/buttons.print.js');
require('datatables.net-plugins/dataRender/datetime.js');

// select2 dropdown
require('select2');
require('../../node_modules/select2/dist/js/i18n/el.js');

// jquery validation
require('jquery-validation');
require('../../node_modules/jquery-validation/dist/localization/messages_el.js');
require('../../node_modules/jquery-validation/dist/additional-methods.js');

// jquery slimscroll
require('jquery-slimscroll');

// moment.js
window.moment = require('moment');

//particles error pages
require('particles.js');

//cleave phone format
require('cleave.js');
require('../../public/js/cleave-phone.js');

// apexcharts graphs
require('pickadate/lib/picker.js');
require('pickadate/lib/picker.date.js');

// lightgallery
require('../../node_modules/lightgallery/lib/picturefill.min.js');
require('../../node_modules/lightgallery/dist/js/lightgallery-all.js');
require('../../node_modules/lightgallery/lib/jquery.mousewheel.min.js');
